// extracted by mini-css-extract-plugin
export default {"image":"l4-z","loaded":"m4-z"};